import { useContext } from 'react';

import { ConfirmIssue, QuotationInfoContext } from '../../../shared';
import { FormIssue } from './components';

export const StepFour = () => {
  const { canShowConfirmIssue } = useContext(QuotationInfoContext);

  return canShowConfirmIssue ? <ConfirmIssue /> : <FormIssue />;
};
